export function formatDate(date: Date | string | number | undefined, opts: Intl.DateTimeFormatOptions = {}) {
  if (!date) return '';

  try {
    return new Intl.DateTimeFormat('en-US', {
      month: opts.month ?? 'long',
      day: opts.day ?? 'numeric',
      year: opts.year ?? 'numeric',
      ...opts,
    }).format(new Date(date));
  } catch {
    return '';
  }
}

export function formatAmount(
  amount: number,
  currency = '円',
  locale = 'en-US',
  options: Intl.NumberFormatOptions = {},
) {
  const formattedAmount = amount.toLocaleString(locale, options);
  return currency ? `${formattedAmount} ${currency}` : formattedAmount;
}
